module.exports = __webpack_public_path__ + "static/img/service5.4dfb3d78.png";